<template>
  <div style="float: left;overflow: hidden;">
    <h2></h2>
    <el-row class="tac" :style="{ minHeight: MHeight }">
      <el-col :style="{ minHeight: MHeight }">
        <el-menu
          :default-active="active"
          :style="{ minHeight: MHeight, position: 'fixed', width: '250px' }"
          class="el-menu-vertical-demo"
          active-text-color="#5B85FF"
          @select="add"
          text-color="#0A101E"
        >
          <img
            v-if="res.entLogo"
            class="logologo"
            :src="this.$store.state.api + res.entLogo"
            alt=""
          />
          <img
            v-if="!res.entLogo"
            class="logologo"
            src="../../assets/images/crm/nav/img.png"
            alt=""
          />
          <div
            style="display: flex;text-align: center;width: 60px;margin: 0 auto;"
          >
            <img
              v-if="res.checkState == 1 ? true : false"
              src="../../assets/images/crm/nav/sh1.png"
              alt=""
            />
            <p v-if="res.checkState == 1 ? true : false">&nbsp;已认证</p>

            <img
              v-if="res.checkState == 0 ? true : false"
              src="../../assets/images/crm/nav/sh0.png"
              alt=""
            />
            <p
              style="color: #5CD48C;"
              v-if="res.checkState == 0 ? true : false"
            >
              审核中
            </p>

            <img
              v-if="res.checkState == 2 ? true : false"
              src="../../assets/images/crm/nav/sh2.png"
              alt=""
            />
            <p
              style="color: #FF4239;"
              v-if="res.checkState == 2 ? true : false"
            >
              审核失败
            </p>
          </div>
          <h3>{{ res.name }}</h3>

          <el-menu-item index="2" v-if="Enterprise">
            <i class="iconfont icon-wendang"></i>
            <span slot="title">注册信息&emsp;</span>
          </el-menu-item>

          <el-menu-item index="1" v-if="TeamManage">
            <i class="iconfont icon-fenzhi"></i>
            <span slot="title">团队成员&emsp;</span>
          </el-menu-item>

          <el-menu-item index="5" v-if="AccManage">
            <i class="iconfont icon-dingdan"></i>
            <span slot="title">账户管理&emsp;</span>
          </el-menu-item>

          <el-menu-item index="8" v-if="GroupingManage">
            <i
              style="font-size: 17px;"
              class="iconfont icon-jijinjingliniren-xuanzhong"
            ></i>
            <span slot="title">投资经理&emsp;</span>
          </el-menu-item>

          <el-menu-item index="3" v-if="InvestorManage">
            <i class="iconfont icon-kaifang"></i>
            <span slot="title">合作方管理</span>
          </el-menu-item>
          <el-menu-item index="4" v-if="ContractManage">
            <i class="iconfont icon-hetong"></i>
            <span slot="title">合作进程&emsp;</span>
          </el-menu-item>

          <el-menu-item index="6" v-if="DataAnalysis">
            <i
              class="iconfont icon-bingtutubiao
                    "
            ></i>
            <span slot="title">数据分析&emsp;</span>
          </el-menu-item>
          <el-menu-item index="7" v-if="RemindSettings">
            <i class="iconfont icon-guanli"></i>
            <span slot="title">提醒设置&emsp;</span>
          </el-menu-item>
        </el-menu>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import "./style.css";
export default {
  props: ["gsName", "val"],
  data() {
    return {
      MHeight: document.documentElement.clientHeight - 54 + "px",
      active: "",
      res: "",
      code: "",
      TeamManage: false,
      Enterprise: false,
      InvestorManage: false,
      ContractManage: false,
      AccManage: false,
      DataAnalysis: false,
      RemindSettings: false,
      GroupingManage: false
    };
  },
  mounted() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    this.getAuthInfo();

    this.$axios
      .post("/crm/mem/queryAllModel", {
        apiToken: this.$store.state.usermsg.apiToken,
        customerId: this.$store.state.usermsg.id
      })
      .then(result => {
        console.log(result);
        // this.tokenInvalid(result);
        if (result.data.code == 200) {
          result.data.data.model.forEach(item => {
            if (item.value == "TeamManage") {
              this.TeamManage = item.selected;
            } else if (item.value == "Enterprise") {
              this.Enterprise = item.selected;
            } else if (item.value == "InvestorManage") {
              this.InvestorManage = item.selected;
            } else if (item.value == "GroupingManage") {
              this.GroupingManage = item.selected;
            } else if (item.value == "ContractManage") {
              this.ContractManage = item.selected;
            } else if (item.value == "AccManage") {
              this.AccManage = item.selected;
            } else if (item.value == "DataAnalysis") {
              this.DataAnalysis = item.selected;
            } else if (item.value == "RemindSettings") {
              this.RemindSettings = item.selected;
            }
          });
        }
      });

    // console.log(this.$route.name)
    if (this.$route.name == "team") {
      this.active = "1";
    } else if (this.$route.name == "mechanism") {
      this.active = "2";
    } else if (
      this.$route.name == "InvestorManage" ||
      this.$route.name == "details"
    ) {
      this.active = "3";
    } else if (
      this.$route.name == "contract" ||
      this.$route.name == "CDetails"
    ) {
      this.active = "4";
    } else if (this.$route.name == "user" || this.$route.name == "uDetails") {
      this.active = "5";
    } else if (
      this.$route.name == "analysis" ||
      this.$route.name == "Fitting"
    ) {
      this.active = "6";
    } else if (this.$route.name == "remindSet") {
      this.active = "7";
    } else if (this.$route.name == "manager") {
      this.active = "8";
    }
  },
  methods: {
    getAuthInfo() {
      this.$axios
        .post("/crm/ent/getAuthInfo", {
          apiToken: this.$store.state.usermsg.apiToken
        })
        .then(res => {
          this.code == res.data.code;
          // this.tokenInvalid(res)
          if (res.data.code == 200) {
            this.res = res.data.data;

            localStorage.setItem("res", JSON.stringify(res.data.data));
            localStorage.setItem("once", true);
          }
        });
    },
    add(e) {
      // console.log(e)
      if (e == "1") {
        this.$router.push("/crm/team");
      } else if (e == "2") {
        this.$router.push("/crm/mechanism");
      } else if (e == "3") {
        this.$router.push("/crm/InvestorManage");
      } else if (e == "4") {
        this.$router.push("/crm/contract");
      } else if (e == "5") {
        this.$router.push("/crm/user");
      } else if (e == "6") {
        this.$router.push("/crm/analysis");
      } else if (e == "7") {
        this.$router.push("/crm/remindSet");
      } else if (e == "8") {
        this.$router.push("/crm/manager");
      }
    }
  },
  watch: {
    val(e) {
      this.$axios
        .post("/crm/ent/getAuthInfo", {
          apiToken: this.$store.state.usermsg.apiToken
        })
        .then(res => {
          if (res.data.code == 200) {
            this.res = res.data.data;

            localStorage.setItem("res", JSON.stringify(res.data.data));
            localStorage.setItem("once", true);
          }
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/crmNav/index.vue